package com.parmartechnologies.core.feature.cart.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
@Serializable
data class CartStoreObject(
    @SerialName("cart_items") var items: List<CartItem> = listOf<CartItem>(),
)